import { render, staticRenderFns } from "./chatDetail.vue?vue&type=template&id=7e40ea03&scoped=true"
import script from "./chatDetail.vue?vue&type=script&lang=js"
export * from "./chatDetail.vue?vue&type=script&lang=js"
import style0 from "./chatDetail.vue?vue&type=style&index=0&id=7e40ea03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e40ea03",
  null
  
)

export default component.exports